/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Aboutpushdescription2Inputs */

const id_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari lebih lanjut tentang cara kerja notifikasi push di EGData.`)
};

const ms_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketahui lebih lanjut tentang cara pemberitahuan push berfungsi di EGData.`)
};

const da_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær mere om hvordan push-notifikationer fungerer på EGData.`)
};

const de_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahren Sie mehr darüber, wie Push-Benachrichtigungen auf EGData funktionieren.`)
};

const en_us2_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more about how push notifications work on EGData.`)
};

const es_es2_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén más información sobre cómo funcionan las notificaciones push en EGData.`)
};

const es_mx2_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprende más sobre cómo funcionan las notificaciones push en EGData.`)
};

const fil_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matuto pa tungkol sa kung paano gumagana ang push notifications sa EGData.`)
};

const fr_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus sur le fonctionnement des notifications push sur EGData.`)
};

const it_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri di più su come funzionano le notifiche push su EGData.`)
};

const hu_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudj meg többet arról, hogyan működnek a push értesítések az EGData-on.`)
};

const nl_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lees meer over hoe pushmeldingen werken op EGData.`)
};

const no_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær mer om hvordan push-varsler fungerer på EGData.`)
};

const pl_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dowiedz się więcej o tym, jak działają powiadomienia push w EGData.`)
};

const pt_br2_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba mais sobre como funcionam as notificações push no EGData.`)
};

const pt_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba mais sobre como funcionam as notificações push no EGData.`)
};

const ro_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Află mai multe despre cum funcționează notificările push pe EGData.`)
};

const fi_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lue lisää siitä, miten push-ilmoitukset toimivat EGDatassa.`)
};

const sv_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lär dig mer om hur push-notiser fungerar på EGData.`)
};

const vi_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm hiểu thêm về cách thông báo đẩy hoạt động trên EGData.`)
};

const tr_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData'da push bildirimlerinin nasıl çalıştığı hakkında daha fazla bilgi edinin.`)
};

const cs_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zjistěte více o tom, jak push oznámení fungují na EGData.`)
};

const bg_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Научете повече за това как работят push известията на EGData.`)
};

const ru_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Узнайте больше о том, как работают push-уведомления на egdata.app`)
};

const uk_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дізнайтеся більше про те, як працюють push-сповіщення на EGData.`)
};

const ar_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعرف على المزيد حول كيفية عمل الإشعارات الفورية على EGData.`)
};

const hi_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData पर पुश सूचनाएँ कैसे काम करती हैं, इसके बारे में और जानें।`)
};

const th_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้เพิ่มเติมเกี่ยวกับวิธีการทำงานของการแจ้งเตือนแบบพุชบน EGData`)
};

const ja_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData でのプッシュ通知の仕組みについて詳しく学ぶ。`)
};

const zh_cn2_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多关于EGData推送通知的工作原理。`)
};

const zh_hant1_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多關於EGData推播通知的運作原理。`)
};

const ko_notifications_aboutpushdescription2 = /** @type {(inputs: Notifications_Aboutpushdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData에서 푸시 알림이 작동하는 방식에 대해 자세히 알아보세요.`)
};

/**
* | output |
* | --- |
* | "Learn more about how push notifications work on EGData." |
*
* @param {Notifications_Aboutpushdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_aboutpushdescription2 = /** @type {((inputs?: Notifications_Aboutpushdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Aboutpushdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_aboutpushdescription2(inputs)
	if (locale === "ms") return ms_notifications_aboutpushdescription2(inputs)
	if (locale === "da") return da_notifications_aboutpushdescription2(inputs)
	if (locale === "de") return de_notifications_aboutpushdescription2(inputs)
	if (locale === "en-US") return en_us2_notifications_aboutpushdescription2(inputs)
	if (locale === "es-ES") return es_es2_notifications_aboutpushdescription2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_aboutpushdescription2(inputs)
	if (locale === "fil") return fil_notifications_aboutpushdescription2(inputs)
	if (locale === "fr") return fr_notifications_aboutpushdescription2(inputs)
	if (locale === "it") return it_notifications_aboutpushdescription2(inputs)
	if (locale === "hu") return hu_notifications_aboutpushdescription2(inputs)
	if (locale === "nl") return nl_notifications_aboutpushdescription2(inputs)
	if (locale === "no") return no_notifications_aboutpushdescription2(inputs)
	if (locale === "pl") return pl_notifications_aboutpushdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_aboutpushdescription2(inputs)
	if (locale === "pt") return pt_notifications_aboutpushdescription2(inputs)
	if (locale === "ro") return ro_notifications_aboutpushdescription2(inputs)
	if (locale === "fi") return fi_notifications_aboutpushdescription2(inputs)
	if (locale === "sv") return sv_notifications_aboutpushdescription2(inputs)
	if (locale === "vi") return vi_notifications_aboutpushdescription2(inputs)
	if (locale === "tr") return tr_notifications_aboutpushdescription2(inputs)
	if (locale === "cs") return cs_notifications_aboutpushdescription2(inputs)
	if (locale === "bg") return bg_notifications_aboutpushdescription2(inputs)
	if (locale === "ru") return ru_notifications_aboutpushdescription2(inputs)
	if (locale === "uk") return uk_notifications_aboutpushdescription2(inputs)
	if (locale === "ar") return ar_notifications_aboutpushdescription2(inputs)
	if (locale === "hi") return hi_notifications_aboutpushdescription2(inputs)
	if (locale === "th") return th_notifications_aboutpushdescription2(inputs)
	if (locale === "ja") return ja_notifications_aboutpushdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_aboutpushdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_aboutpushdescription2(inputs)
	return ko_notifications_aboutpushdescription2(inputs)
});
export { notifications_aboutpushdescription2 as "notifications.aboutPushDescription" }